import { render } from "./ModelChangeConfirmationComponent.vue?vue&type=template&id=2780fba6&scoped=true"
import script from "./ModelChangeConfirmationComponent.vue?vue&type=script&lang=js"
export * from "./ModelChangeConfirmationComponent.vue?vue&type=script&lang=js"

import "./ModelChangeConfirmationComponent.vue?vue&type=style&index=0&id=2780fba6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2780fba6"]])

export default __exports__